import React from 'react';
import { Hero } from '../components/Hero';
import { AbismoSection } from '../components/AbismoSection';
import { HookSection } from '../components/HookSection';
import { EvidenceSection } from '../components/EvidenceSection';
import { UrgencySection } from '../components/UrgencySection';
import { AudienceSection } from '../components/AudienceSection';
import { AuthorSection } from '../components/AuthorSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PaymentSection } from '../components/PaymentSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-black flex flex-col selection:bg-[#D4AF37] selection:text-black" data-id="element-145">
      <Hero data-id="element-146" />
      <AbismoSection data-id="element-147" />
      <HookSection data-id="element-148" />
      <EvidenceSection data-id="element-149" />
      <UrgencySection data-id="element-150" />
      <AudienceSection data-id="element-151" />
      <AuthorSection data-id="element-152" />
      <TestimonialsSection data-id="element-153" />
      <PaymentSection data-id="element-154" />
      <ClosingSection data-id="element-155" />
      <Footer data-id="element-156" />
    </main>;
}